import React, { useMemo } from 'react'
import { Card, CardBody, Badge } from 'reactstrap'
import { GST_STALL_LIST, ORDER_STATUS } from '@common'
import './OrderItem.css'

const statusBadge = {
    Unpaid: { text: 'Please make payment', color: 'danger' },
    Paid: { text: 'Order sent to stall', color: 'warning' },
    Completed: { text: 'Ready for collection', color: 'primary' },
}

const OrderItem = ({ item }) => {
    const renderItemDetails = useMemo(
        () => orderItem => {
            const { variant, selections } = orderItem
            const selectionText = selections
                .reduce((acc, selection) => {
                    const selectedOptions = selection.options
                    return [...acc, ...selectedOptions.map(option => `${option.name} x ${option.quantity}`)]
                }, [])
                .join(', ')

            const selectionPrice = selections.reduce((acc, selection) => {
                const selectedOptions = selection.options
                return acc + selectedOptions.reduce((optionTotal, option) => optionTotal + option.sellPrice * option.quantity, 0)
            }, 0)

            const totalPrice = variant.sellPrice + selectionPrice
            // const completedCount = variant.completedCount || 0
            // const preparingCount = variant.quantity - completedCount

            return (
                <div key={variant.id} className="variant-item">
                    <div className="variant-header">
                        <div className="variant-info">
                            <p className="variant-name">{variant.name === 'Default Title' ? item.name : variant.name}</p>
                            {selectionText && <p className="selection-text">{selectionText}</p>}
                            {variant.pickupSlotNumber && (
                                <p
                                    className="pickup-slot-text"
                                    style={{
                                        fontSize: '18px',
                                        color: '#28a745',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Pickup Slot: #{variant.pickupSlotNumber}
                                </p>
                            )}
                        </div>
                    </div>
                    <div>
                        <div className="variant-price-info d-flex justify-content-end">
                            <p className="variant-price">${totalPrice.toFixed(2)}</p>
                            <p className="variant-quantity ms-1">× {variant.quantity}</p>
                        </div>
                        {GST_STALL_LIST.includes(item?.stallName) && (
                            <div className="d-flex justify-content-end mt-2">
                                <p className="text-dark m-0" style={{ fontSize: '12px' }}>
                                    (Inclusive of GST)
                                </p>
                            </div>
                        )}
                    </div>
                    {/* <div className="variant-status">
                        {preparingCount > 0 && (
                            <span className="status-tag preparing">
                                {preparingCount} preparing
                            </span>
                        )}
                        {completedCount > 0 && (
                            <span className="status-tag completed">
                                {completedCount} ready
                            </span>
                        )}
                    </div> */}
                </div>
            )
        },
        [item]
    )

    return (
        <Card className="order-status-card">
            <CardBody className="p-0">
                <div className="order-item">
                    <div className="item-status">
                        <Badge color={statusBadge[item.status].color || 'secondary'}>{statusBadge[item.status].text}</Badge>
                        {item.status === ORDER_STATUS.PAID && (
                            <Badge className="queue-badge">
                                {item.pendingOrdersAhead > 0 ?
                                    `In Queue • ${item.pendingOrdersAhead} ${item.pendingOrdersAhead === 1 ? 'order' : 'orders'} ahead`
                                :   'Preparing'}
                            </Badge>
                        )}
                    </div>
                    <div>
                        <div className="d-flex align-items-center mt-1">
                            <i className="bx bx-store bx-sm me-3"></i>
                            <p className="item-vendor-text">{item.vendorName}</p>
                        </div>
                        <div className="d-flex align-items-center mb-3">
                            <i className="bx bx-restaurant bx-sm me-3"></i>
                            <h6 className="item-title-text">{item.name}</h6>
                        </div>

                        <div className="item-details">
                            <div className="variant-container">{item.items.map(orderItem => renderItemDetails(orderItem))}</div>
                        </div>
                    </div>
                </div>
            </CardBody>
        </Card>
    )
}

export default OrderItem
